import { SearchDuration } from "@apply4u/models/search/search-duration";

export const JobSearchDurations: SearchDuration[] = [
    { Id: -1, Description: "Search within last" },
    { Id: 0, Description: "Anytime" },
    { Id: 1, Description: "Today" },
    { Id: 3, Description: "Last three days" },
    { Id: 7, Description: "Last week" },
    { Id: 14, Description: "Last two weeks" },
    { Id: 30, Description: "1 month" },
];